// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2803":"a718bc46","4559":"24a89222","8974":"58a35938"}[chunkId] + ".chunk.css";
};